export default {

	namespaced: true,

	state: {
		history: [] as number[][][],
		historyIndex: 0,
		hasChanges: false,
	},

	
	getters: {
		canUndo(state):boolean {
			return state.historyIndex > 1;
		},

		canRedo(state) {
			return state.historyIndex < state.history.length;
		},
	},

	mutations: {

		setHistory(state, history) {
			state.history = history;
		},

		setHistoryIndex(state, historyIndex) {
			state.historyIndex = historyIndex;
		},

		setHasChanges(state, hasChanges) {
			state.hasChanges = hasChanges;
		},

	},

	actions: {

		saved({commit}) {
			commit("setHasChanges", false);
		},

		reset({commit}, route:number[][]) {
			commit("setHistoryIndex", 1);
			commit("setHistory", [route]);
			commit("setHasChanges", false);
		},

		do({ state, commit }, route:number[][]) {
			const history = state.history.slice(0, state.historyIndex);
			history.push( route );
			commit("setHistory", history);
			commit("setHistoryIndex", history.length);
			commit("setHasChanges", true);
		},

		undo({state, commit, dispatch, getters}) {
			if(getters.canUndo) {
				commit("setHistoryIndex", state.historyIndex-1);
				commit("setHasChanges", true);
				const current = state.history[state.historyIndex-1];
				dispatch("onUndoRedo", current, {root:true});
			}
		},

		redo({state, commit, dispatch, getters}) {
			if(getters.canRedo) {
				commit("setHistoryIndex", state.historyIndex+1);
				commit("setHasChanges", true);
				const current = state.history[state.historyIndex-1];
				dispatch("onUndoRedo", current, {root:true});
			}
		},
	}
}